import { $api } from "@/shared/api";

// Лимит разборов на сутки и сколько матчей разобрано (экран «Профиль»). Её `queryKey`
// инвалидируют `analysis.done` (разобран ещё матч) и `analysis.failed` (упавший лимит не тратит).
export const analysisUsageQueryOptions = () => $api.queryOptions("get", "/api/analyses/usage");
